import LanguagePicker from './LanguagePicker.jsx';

import './language-picker-media-screen.scss';

export default LanguagePicker;
